module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_an@3x-d8bbc2454032b867fa4775858786d76c.webp";